export const brand = {
	name: "Room is Full",
	description:
		"Find your conference. Plan your sessions, save your notes and share your schedule.",
	appUrl: "https://roomisfull.app",
	aliases: [
		"https://roomisfull.com",
		"https://www.roomisfull.app",
		"https://www.roomisfull.com",
	],
	themeColor: "#0f172a",
	repository: "https://github.com/nicholasgriffintn/fosdem-pwa",
};
